<template>
  <div>
    <van-nav-bar title="工会俱乐部" />
    <div v-if="showClubs">
      <div v-for="club in clubList" style="margin-top:1rem">
        <div style="margin-bottom:1rem" class="title">{{club.clubName}}</div>
          <table v-for="item in club.items" width="100%">
            <tr>
              <td width="45%">{{item.time}}</td>
              <td>{{item.address}}</td>
            </tr>
          </table>
        <div style="border-bottom:1px solid rgb(7,193,96,0.6);margin-top:1rem"></div>
        <div style="margin-top:0.5rem">部长：{{club.owner}}
        <!-- ({{club.email}}) -->
        </div>
        <div v-if="club.mailer!=''" style="margin-top:0.5rem">mailer：{{club.mailer}}</div>
      </div>
    </div>
    <div style="margin-bottom:2rem"></div>
  </div>
</template>

<style type="text/css" scoped>
  .title{
    height: 40px;
    line-height: 40px;
    background-color: #07c160;
    color: white;
    border-radius: 5px;
  }
  table{
    table-layout: fixed;
    /*border-top:1px solid #F00;border-left:1px solid #F00;*/       
  }
  table:nth-child(odd){
    background-color: #DFFFDF;
  }
  table td{
    /*border-right:1px solid #F00;border-bottom:1px solid #F00;*/
    padding:0.3rem;
    word-break:break-all;
    font-size: 10px;
  }

</style>

<script>
import axios from 'axios';
import { Calendar, Cell, Button, Dialog, NavBar, Toast, RadioGroup, Radio, Form, Tabbar, TabbarItem, List } from 'vant';

export default {
    name: 'Clubs',
    data () {
      return {
        clubList:[],
        showClubs: false
      }
    },
    mounted(){
        let vm = this;
        //console.log("Load Clubs data...");
        axios.get('/api/getClubs').then((res) => {
          //console.log(res.data);
          vm.clubList = res.data;
          vm.showClubs = true;
        }).catch((error) => {
          alert("Internal server error!");
        });
    },
    methods: {
    },
    watch: {
      
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/Clubs.vue